import { render, staticRenderFns } from "./ProductRowComponent.vue?vue&type=template&id=50c61732&scoped=true&"
import script from "./ProductRowComponent.vue?vue&type=script&lang=js&"
export * from "./ProductRowComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductRowComponent.vue?vue&type=style&index=0&id=50c61732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c61732",
  null
  
)

export default component.exports